module.exports = __webpack_public_path__ + "img/2_229.6d4e791e.png";